import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@asambleas-env/environment';
import { ConceptValues } from '@asambleas-models/concept-values.model';
import { Church } from '@asambleas-models/church.model';
import { Member } from '@asambleas-models/member.model';
import { Planter } from '@asambleas-models/planter.model';
import { Minister } from '@asambleas-models/minister.model';
import { Concept } from '@asambleas-models/concept.model';

/**
 * Contiene todas la funciones que son comunes entre módulo (App, Admin y User)
 */
@Injectable()
export class GeneralService {

    public concepts: { [id: string]: ConceptValues } = {};
    public churches: { [id: string]: Church } = {};
    public members: { [id: string]: Member } = {};
    public planters: { [id: string]: Planter } = {};
    public ministers: { [id: string]: Minister } = {};

    constructor(public http: HttpClient) {
        this.loadConcepts()
    }

    getConceptDataById(id: number) {
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=utf-8'
        };

        return this.http.get(environment.apiEndPoint + '/concepto/' + id, {
            headers
        });
    }

    loadConcepts() {
        // documentTypes
        this.getConceptDataById(1).subscribe((data: Concept) => this.concepts[1] = data.values);

        // maritalStatus
        this.getConceptDataById(2).subscribe((data: Concept) => this.concepts[2] = data.values);

        // gender
        this.getConceptDataById(3).subscribe((data: Concept) => this.concepts[3] = data.values);

        // planterStates
        this.getConceptDataById(5).subscribe((data: Concept) => this.concepts[5] = data.values);

        // cities
        this.getConceptDataById(6).subscribe((data: Concept) => this.concepts[6] = data.values);

        // fulfillmentStates
        this.getConceptDataById(7).subscribe((data: Concept) => this.concepts[7] = data.values);

        // address list
        this.getConceptDataById(9).subscribe((data: Concept) => this.concepts[9] = data.values);

        // ministers level
        this.getConceptDataById(10).subscribe((data: Concept) => this.concepts[10] = data.values);

        // academic level
        this.getConceptDataById(11).subscribe((data: Concept) => this.concepts[11] = data.values);

        // ministerial type formation
        this.getConceptDataById(12).subscribe((data: Concept) => this.concepts[12] = data.values);

        // ministers type
        this.getConceptDataById(13).subscribe((data: Concept) => this.concepts[13] = data.values);

        // church type
        this.getConceptDataById(14).subscribe((data: Concept) => this.concepts[14] = data.values);

        // STATUS CREDENTIAL RENOVATION
        this.getConceptDataById(15).subscribe((data: Concept) => this.concepts[15] = data.values);
    }

    getDocumentType(type) {
        let documentName = '';
        Object.keys(this.concepts[1]).forEach((key, index) => {
            if (this.concepts[1][key].value === type) {
                documentName = this.concepts[1][key].description;
            }
        });
        return documentName;
    }

    getCivilStatus(type) {
        let civilStatus = '';
        Object.keys(this.concepts[2]).forEach((key, index) => {
            if (this.concepts[2][key].value === type) {
                civilStatus = this.concepts[2][key].description;
            }
        });
        return civilStatus;
    }

    /**
	 * Dado un array de elementos los vacia
	 * el obejtivo de esta función es evitar array = []
	 *
	 * @param {Array<any>} a
	 * @memberof FunctionService
	 */
    emptyArray(a: Array<any>) {
        while (a.length) {
            a.pop();
        }
    }

    getHeadersUser() {
        const token = localStorage.getItem('id_token');
        const headers = {
            'Accept': 'application/json',
            'Authorization': token
        };

        return { headers: headers };
    }

    uploadAvatarToUser(body) {
        return this.http.post(environment.apiEndPoint + '/upload-avatar', body, this.getHeadersUser());
    }

    uploadAvatarToChurch(body) {
        return this.http.post(environment.apiEndPoint + '/upload-church-avatar', body, this.getHeadersUser());
    }

    isLogged() {
        if (localStorage.getItem('user') && localStorage.getItem('id_token')) {
            return true;
        }
        else {
            return false;
        }
    }

    isAdmin() {
        if (this.isLogged()) {
            let user = JSON.parse(localStorage.getItem('user'));

            for (let rol of user.roles) {
                if (rol.level == 1) {
                    return true;
                }
            }

        }
        return false;
    }

    formatBirthDate(d: Date) {
        let year = d.getFullYear()
        let month = "" + (Number(d.getMonth()) + 1)
        if (month.length < 2) {
            month = "0" + month.toString()
        }
        let day = "" + d.getDate()
        if (day.length < 2) {
            day = "0" + day
        }

        let formattedDate = year + '-' + month + '-' + day

        return formattedDate
    }

    /* METODO PARA OBTENER UN VALOR DE LA LISTA DE VALORES, A TRAVES DE SU VALOR Y LA CORRESPONDIENTE LISTA */
    getConcept(value: string, conceptId: number) {
        let returnValue = '';
        const documentTypes = this.concepts[conceptId];

        // SE AGREGA VALIDACIÓN PARA ESPERAR QUE CARGUEN CORRECTAMENTE
        if (documentTypes) {
            Object.keys(documentTypes).forEach((key) => {
                if (value == documentTypes[key]['value']) {
                    returnValue = documentTypes[key]['description']
                }
            });
        }

        return returnValue
    }
}



// WEBPACK FOOTER //
// ./src/app/services/general/general.service.ts